<template>
  <b-collapse id="filter-box">
    <v-card flat class="pa-3">
      <v-container fluid>
        <v-row>
          <v-col cols="12" lg="6" class="mb-5">
            <v-text-field
              label="Search by Candidate Name, ID, Phone Number, or Email"
              outlined
              dense
              hide-details
              v-model.trim="filters.search"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6" class="mb-5">
            <v-select
              :items="phoneVerifiedOptions"
              label="Phone Verified"
              item-text="text"
              item-value="value"
              outlined
              dense
              hide-details
              v-model="filters.verified"
              :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>
          </v-col>
          <v-col cols="12" lg="6" class="mb-5">
            <v-select
              :items="roles"
              label="Role"
              item-text="name"
              item-value="id"
              outlined
              dense
              hide-details
              v-model="filters.role"
              :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>
          </v-col>
          <v-col cols="12" lg="6" class="mb-5">
            <v-select
              :items="callStatusOptions"
              label="Call Status"
              item-text="text"
              item-value="value"
              outlined
              dense
              hide-details
              v-model="filters.call_status"
              :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>
          </v-col>
          <div class="w-100">
            <v-col cols="12" lg="6" class="mb-5">
              <v-select
                :items="outputStatusOptions"
                label="Output Status"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details
                v-model="filters.output_status"
                :menu-props="{ bottom: true, offsetY: true }"
              ></v-select>
            </v-col>
          </div>

          <div class="col-6 col-lg-6 mb-5">
            <button
              class="btn btn-info font-weight-bolder font-size-h6 px-5 col"
              @click="applyFilter"
            >
              Apply
            </button>
          </div>
          <div class="col-6 col-lg-6 mb-5">
            <button
              class="btn btn-secondary font-weight-bolder font-size-h6 px-5 col"
              @click="resetQuery"
            >
              Reset
            </button>
          </div>
        </v-row>
      </v-container>
    </v-card>
  </b-collapse>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const initQuery = {
  search: "",
  verified: null,
  role: null,
  call_status: null,
  output_status: null,
};

export default {
  name: "AIAgentOTPResultsFilter",
  data() {
    return {
      filters: { ...initQuery },
      phoneVerifiedOptions: [
        { value: 1, text: "Verified" },
        { value: 0, text: "Not Verified" },
      ],
      callStatusOptions: [
        { value: "initiated", text: "Initiated" },
        { value: "completed", text: "Completed" },
        { value: "issue_with_provider", text: "Issue with Provider" },
      ],
      outputStatusOptions: [
        { value: "pending", text: "Pending" },
        { value: "answered", text: "Answered" },
        { value: "not_answered", text: "Not Answered" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      roles: "talents/getRoles",
    }),
  },
  methods: {
    ...mapActions({
      getRoles: "talents/getRoles",
    }),
    applyFilter() {
      const {
        search,
        verified,
        role,
        call_status,
        output_status,
        call_type,
      } = this.filters;

      // Check if at least one filter is applied
      if (
        !search &&
        verified === null &&
        !role &&
        !call_status &&
        !output_status &&
        !call_type
      ) {
        this.$toasted.show("Please Add At Least One Filter", {
          type: "error",
          icon: "error",
        });
        return;
      }

      // Prepare data object with applied filters
      let data = {};
      if (search) data.search = search;
      if (verified !== null) data.verified = verified;
      if (role) data.role = role;
      if (call_status) data.call_status = call_status;
      if (output_status) data.output_status = output_status;
      if (call_type) data.call_type = call_type;

      // Emit the applyFilter event with the data
      this.$emit("applyFilter", data);
    },
    resetQuery() {
      this.filters = { ...initQuery };
      this.$emit("resetQuery");
    },
  },
  created() {
    this.getRoles();
  },
};
</script>

<style scoped>
.v-card {
  margin-bottom: 20px;
  background-color: #ffffff;
  border-radius: 5px;
}
.v-card-title {
  font-weight: bold;
}
</style>
